import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSession } from '@ghq-abi/auth-client-lib/client';
import mixpanel from 'mixpanel-browser';

import { initMixpanel } from '../../../mixpanelClient';
import { isLocal } from '../utils/environments';

type MixpanelSessionUser = {
    employeeId?: string;
    eid?: string;
    globalId?: string;
    gid?: string;
    band?: string;
    zone?: string;
    roles?: string[] | Record<string, boolean> | string;
    country?: string;
    ctry?: string;
    isManager?: boolean;
    name?: string;
};

type MixpanelSession = {
    user?: MixpanelSessionUser;
} | null;

export function useInitMixPanel() {
    const router = useRouter();
    const { data } = useSession();

    useEffect(() => {
        initMixpanel();

        if (!data || !process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || isLocal()) {
            return;
        }

        try {
            const user = (data as MixpanelSession)?.user;
            const distinctId = user?.globalId ?? user?.gid;

            if (distinctId) {
                mixpanel.identify(distinctId);
            }

            mixpanel.people.set({
                globalId: user?.globalId ?? user?.gid,
                band: user?.band,
                zone: user?.zone,
                roles: user?.roles,
                country: user?.country ?? user?.ctry,
                isManager: user?.isManager,
                $name: user?.name,
            });
        } catch {
            console.error('Failed to init mixpanel');
        }
    }, [data, router.events]);
}
